/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
// components/Counter.tsx
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState,  } from "react";
import { bindActionCreators } from "redux";
import "./steper3.scss";
import Steper from "../../components/steper/Steper";
import axios from "axios";
import { redirect, useLocation, useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../store/reducers";
import { actionCreators } from "../../store";
import { transformCartToDesiredArray } from "../../helper/checkoutFunction";
import FreezScreen from "../../components/FreezScreen";
import Cart from "../../components/cart/cart";
import PaymentMethods from "../../components/paymentMethods/paymentMethods";
import CategoryBanner from "../../components/CategoryBanner/CategoryBanners";
import TableInfo from "../../components/tableInfo";
import { withTranslation, useTranslation } from "react-i18next";
import NewNextBtn from "../../components/BtnNext/NewNextBtn";
import { erase, getCookie, setCookie } from "../../helper/cookieFunction";
import { apiService } from "../../services";
import DiscountBanners from "../../components/discountBanners/DiscountBanners";
import LoginModalv2Popup from "../../components/loginSignUp/LoginModalv2Popup";
import VerifyPhoneNumberv2Popup from "../../components/loginSignUp/VerifyPhoneNumberv2Popup";
const Step3 = () => {
  const {t} = useTranslation()
  const state = useSelector((state: RootState) => state.appReducer);
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { paymentMethodPopUp, freezScreen, redirectCheckout, pendingCheckout, loginValues, loginModal, otpModal } = state;
  const { storeId, storeInfo } = apiState;  
  const dispatch = useDispatch();
  const {setCart,setBookingForm,freezScreenState,setPaymentMethodPopUp,alertMessageState,setAuthToken,setBookingTotal,userInfoState, setRedirectCheckout, setLoginModal, setPendingCheckout, setOtpModal, setLoginState, setGuestLoggedIn, setLoggedOut } = bindActionCreators(actionCreators, dispatch);
  const navigate = useNavigate();
  const { slug='enabill' } = useParams();
  const { search } = useLocation();
  const searchParams: any = new URLSearchParams(search);
  const [bId] = useState(searchParams.get("bId"));
  const [comeFromAuth, setComeFromAuth] = useState(searchParams.has('appLoggedIn'));
  let authMount = false
  const childRef: any = useRef();
  const [tapId, setTapId]: any = useState("");
  const hasExtras: boolean = window.location.pathname == `/${slug}/step-3`
  let payByCash = ['haute-dolci-online','kul-kuwait-city','hassan-ki-dukan-main'].includes(slug);
  const [paymentMethod, setPaymentMethod] = React.useState(null);
  const [cardDetails, setCardDetails] = useState(null);
  const [cardDiscounted, setCardDiscounted] = useState([]);
  const [isLoadingCardDiscounted, setIsLoadingCardDiscounted] = useState(true); 
  const [otpIsRequired, setOtpIsRequired] = useState(false);
  useEffect(() => {
    setOtpIsRequired(!!storeInfo?.otp);
  }, [storeInfo]);
  useEffect(() => {
    freezScreenState(false);
  }, [storeId]);

  const resetLoginSession = () => {
    erase("tokenAuth");
    erase("Profile");
    setAuthToken("");
    setLoggedOut(null);
    userInfoState({});
    setGuestLoggedIn(false);
    setLoginModal(false);
    setOtpModal(false);
    setPendingCheckout(false);
    setLoginState({
      phoneCode: "965",
      phoneNumber: "",
      fullName: "",
      email: "",
      provider: "",
      storeId: "",
      branchId: "",
    });
  };

  const orderInvoice = async () => {
    freezScreenState(true);
    let payload: any = {
      booking_date: state?.bookingForm?.bookingDate,
      time_id: state?.bookingForm?.bookingTimeInd,
      guests: state?.bookingForm?.NoGuest,
      device_id: state?.deviceId,
      extras: transformCartToDesiredArray(state.cart), 
      payment_source: (Number(state?.bookingTotal?.sumOfTotal) > 0 &&  !payByCash)  ? paymentMethod : `cash`,
      token: tapId != "" ? tapId : null,
      save_card: false,
      card_id: null,
      package_id: state?.bookingForm?.packageId,
      card_detail: cardDetails ? cardDetails : null
    };
    if (!otpIsRequired) {
      payload.name =
        state?.userInfo?.userFirstName ||
        state?.userInfo?.name ||
        loginValues?.fullName ||
        null;
      payload.number =
        state?.userInfo?.number ||
        loginValues?.phoneNumber ||
        null;
      payload.country_code =
        state?.userInfo?.countryCode ||
        loginValues?.phoneCode ||
        null;
      const guestEmail = state?.userInfo?.email || loginValues?.email || null;
      if (guestEmail) {
        payload.email = guestEmail;
      }
    }
    let response: any = null;
    const headers =
      otpIsRequired && getCookie("tokenAuth")
        ? { Authorization: `Bearer ${getCookie("tokenAuth")}` }
        : {};
    if ((otpIsRequired && getCookie("tokenAuth")) || !otpIsRequired) {
      try {
        response = await axios.post(
          `${process.env.REACT_APP_API_URL}/booking/customer/add`,
          payload,
          { headers }
        );
      } catch (e: any) {
        console.error("New Api store not found", e);
        alertMessageState({
          type: "error",
          show: true,
          message: e.response.data.message,
        });
        if(e.response.status == 401){
        erase("tokenAuth");
        erase("Profile");
        goToAuth(true)
        }
  
  
      }
      }
      else
      {
        handleCheckoutFunc()
      }

    
    if (response != null) {
        if (response.data.success === true) {


          if (
            response.data.success === true &&
            response.data.data.url &&
            response.data.data.url != null
          ) {
            setRedirectCheckout(true)
            setBookingForm(null);
            setCart([]);
            resetLoginSession();
            const winUrl: any = window.open(`${response.data.data.url}`, "_self");
            winUrl.focus();
          }else{
          setBookingForm(null);
          setCart([]);
          resetLoginSession();
          alertMessageState({
            type: "success",
            show: true,
            message: response?.data?.message,
          });
          freezScreenState(false);
          // navigate(`/${slug}`);
        }
        } else {
          freezScreenState(false);

          alertMessageState({
            type: "error",
            show: true,
            message: response.data.message,
          });
      }
    } else {
      freezScreenState(false);

    }

  };
  const hasGuestContact = () =>
    !!(loginValues?.fullName?.trim() && loginValues?.phoneNumber);

  const needsContact = () => {
    if (otpIsRequired) {
      return !getCookie("tokenAuth") && !getCookie("Profile");
    }
    return !hasGuestContact();
  };

  const goToAuth = (resumeCheckout = true) => {
    if (otpIsRequired && getCookie("tokenAuth") && getCookie("Profile")) {
      // freezScreenState(true);
      setAuthToken(getCookie("tokenAuth"));
      userInfoState(JSON.parse(getCookie("Profile")))
    } else {
      freezScreenState(false);
      setPendingCheckout(!!resumeCheckout);
      setLoginModal(true);
    }
  };

  useEffect(() => {
    const ready = otpIsRequired
      ? getCookie("tokenAuth") && getCookie("Profile")
      : hasGuestContact();
    if (pendingCheckout && ready && !loginModal) {
      if (paymentMethod == "apple_pay") return;
      setPendingCheckout(false);
      if (paymentMethod == "card") {
        childRef?.current?.submitRequest();
      } else {
        orderInvoice();
      }
    }
  }, [pendingCheckout, state.authToken, loginValues, loginModal]);

  useEffect(() => {
    if (tapId != null && tapId != "") {
      orderInvoice();
    }
  }, [tapId]);
  
  const handleCheckoutFunc = async () => {
    if(needsContact()){
      goToAuth(true);
    }
    else{
      if (paymentMethod == "card") {
        childRef?.current?.submitRequest();
      } else {
        orderInvoice();
      }
    }
   
  };

  const handleGetGuestPricing = async () => {
    const {slotId, bookingPrice , slotPrice , NoGuest }  = state?.bookingForm;
    let guest_prices: any = [];
    try {
      const response: any = await apiService.getGuestPricing(slotId);
      if (response != null) {
        if (response.data.success) {
      let slotsPricings = response.data.data || [];
          if(slotsPricings?.length>0)
            {
              let basicPrice = Number(Number(bookingPrice) + Number(slotPrice))
              let total = 0
              let processedGuests: any = new Set(); // To track guests that have been processed

              for (var i = 0; i < Number(NoGuest); i++) {
                  // Ensure the index does not exceed the array length
                  if (i >= slotsPricings.length) break;
              
                  let currentPricing = slotsPricings[i];
                  let guests = currentPricing?.guests || [];
              
                  // Iterate over the range 1 to NoGuest (e.g., 1 to 6)
                  for (let guestNumber = 1; guestNumber <= Number(NoGuest); guestNumber++) {
                      // If the guest has already been processed, skip
                      if (processedGuests.has(guestNumber)) {
                          continue;
                      }
                      // Check if the current guest is in the pricing list
                      if (guests.some((guest: any) => Number(guest) === guestNumber)) {
                          let calculatedDiscount = 0;
                          let newPrice = Number(currentPricing?.price) + basicPrice;
                          // If there's a discount, calculate it
                          if (currentPricing?.discount) {
                              let discount = currentPricing.discount;
              
                              if (Number(discount.percent) > 0) {
                                  calculatedDiscount = newPrice * (Number(discount.percent) / 100);
                                  // Cap the discount at the maximum discount amount
                                  if (calculatedDiscount > Number(discount.max)) {
                                      calculatedDiscount = Number(discount.max);
                                  }
                              } else if (Number(discount.amount) > 0) {
                                  calculatedDiscount = Number(discount.amount);
                              }
                              newPrice = newPrice - calculatedDiscount;
                              total = total + newPrice ;
                          } else {
                              // No discount, just add the new price to the total
                              total = total + newPrice;
                          }
                          guest_prices.push({
                            id: guestNumber,
                            title: `Guest ${guestNumber}`,
                            price: newPrice,
                          })
                          // add kro jo ho gaya
                          processedGuests.add(guestNumber);
              
                          // Break the loop for this pricing, as we've processed the guest
                          // break;
                      }
                      // else{
                      //   total = total + basicPrice
                      //   guest_prices.push({
                      //     id: guestNumber,
                      //     title: `Guest ${guestNumber}`,
                      //     price: basicPrice,
                      //   })
                      // }
                  }
                  if(i == Number(NoGuest)-1){
                    let fullRange = Array.from({ length: Number(NoGuest) }, (_, i) => i + 1);
                    // Filter out the numbers that are not in the original array
                    if(fullRange?.length>0){
                      let missingNumbers = fullRange.filter(num => !processedGuests.has(num));
                      missingNumbers.forEach((ele:any) => {
                        total = total + basicPrice
                        guest_prices.push({
                          id: ele,
                          title: `Guest ${ele}`,
                          price: basicPrice,
                        })
                      });
                    }
                  }
              }
                
              let reservationFee = Number(total)  
               guest_prices.sort((a: any, b: any) => a.id - b.id);
              setBookingTotal({
                ...state.bookingTotal,
                reservationFee: reservationFee,
                sumOfTotal: Number(state.bookingTotal?.cartTotal) + Number(reservationFee),
                diffGuestPrices: guest_prices
              });

            }
        
        } else {
         navigate(`/${slug}`);
          alertMessageState({
            type: "success",
            show: true,
            message: response?.data?.message,
          });
          freezScreenState(false);
          setBookingForm(null);
          setCart([]);
          resetLoginSession();
        }
      } else {
        
        alertMessageState({
          type: "error",
          show: true,
          message: response?.data?.message,
        });
      }
    } catch (error) {
      console.error(error);
      freezScreenState(false);
    }
  }

  const handleGetBobiyanDiscount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/discounted-card?branch=${storeInfo?.branchId}`,
        {
          headers: {
            ContentType: "application/json",
            // Authorization: `Bearer ${getCookie("tokenAuth")}`,
          },
        }
      );
      
      if(response.data.success){
        // dummy data requried
         let data: any = [];
        response.data.data.forEach((element: any) => {
          if(element?.discount?.percent > 0 && element?.status){
          data.push({
            id: element.id,
            name: element.name,
            discount: element?.discount?.percent ?? 0, 
            description: element?.description?.en,
            type: element?.discount?.percent ? 1 : 2, // 1 for percentage, 2 for amount
          })
        }});
        
        setCardDiscounted(data as any)
        setIsLoadingCardDiscounted(false);
      }      
    } catch (e) {
      if (e instanceof Error && e.message === "ERR_NETWORK") {
        alertMessageState({
          type: "error",
          show: true,
          message: "Please check your network.",
        });
      } 
    } finally {
      setIsLoadingCardDiscounted(false);
    }
  }

  useEffect(() => {
    freezScreenState(false);
    setPaymentMethodPopUp(false);
    setLoginModal(false);
    setOtpModal(false);
    handleGetBobiyanDiscount();
    if(state.bookingForm?.hasGuestPricing && state?.bookingForm?.slotsType == 1){
      // handleGetGuestPricing();
    }
    
  }, []);
useEffect(() => {
 if(comeFromAuth && !authMount){
  let payVal = searchParams.get('paymentMethod')
  authMount = true
  if(!payByCash){
    setPaymentMethodPopUp(true)  
  }
  if(payVal){
    setPaymentMethod(payVal)
  }
 }
 if (getCookie("tokenAuth") && getCookie("Profile")) {
  setAuthToken(getCookie("tokenAuth"));
  userInfoState(JSON.parse(getCookie("Profile")))
} 
}, [comeFromAuth])
useEffect(() => {
  if(comeFromAuth && paymentMethod != null &&  paymentMethod  !=  'null' && paymentMethod != 'apple_pay'){
  // setComeFromAuth(false)

    handleCheckoutFunc()
  }
}, [paymentMethod])


  const handleGoBack = () => {
    let hasExtras = state?.bookingForm?.bookingCategory?.hasExtras;
    
    setPaymentMethodPopUp(false);
    if (hasExtras) {
      navigate(`/${slug}/step-2?bId=${bId}`);
    } else {
      navigate(`/${slug}/step-1?bId=${bId}`);
    }
  };
  useEffect(() => {
    if(redirectCheckout){
      freezScreenState(true);
    }
  }, [redirectCheckout])

  const [showOfferPopup, setShowOfferPopup] = useState(false);

  return (
    <React.Fragment>
      <LoginModalv2Popup />
      <VerifyPhoneNumberv2Popup />
      {(freezScreen || redirectCheckout) && <FreezScreen />}
      <div id="Steper3" className={` ${state.langValue === "ar" ? `direction-rtl` : "direction-ltr"
        }`}>
        <CategoryBanner handleGoBack={handleGoBack} />
        <div  style={{height: '90vh'}}>
          <div className="px-3" >
            <div className="mb-4" >
              <Steper
                label={t("step3.Summary")}
                labelDecs=''
                steps={true}
                stepNo={3}
                howMaysteps={hasExtras ? 3 : 2}

              />
              <TableInfo />
              
         


              <Cart state={state} />
             
            </div>
           
            <NewNextBtn
              label={payByCash ? t("Reserve") : t("custom-msg.CheckOut")}
              handleCheckout={ () => {
                if (Number(state?.bookingTotal?.sumOfTotal)  > 0 && !payByCash) {
                  setPaymentMethodPopUp(true);
                  return;
                }
                if (needsContact()) {
                  goToAuth(true);
                  return;
                }
                orderInvoice();
              } }
              showPayIcons={payByCash ? false :true}
            // handleCheckout={undefined}
            />
          </div>
          {cardDiscounted.length > 0 ?
                  <DiscountBanners data={cardDiscounted}  isLoadingCardDiscounted={isLoadingCardDiscounted} setShowOfferPopup={setShowOfferPopup} showOfferPopup={showOfferPopup}/>
                      : '' 
                }
          {paymentMethodPopUp && (
            <PaymentMethods
              handleCheckoutFunc={handleCheckoutFunc}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              childRef={childRef}
              setTapId={setTapId}
              setButtonLoading={freezScreen}
              status={"checkout"}
              goToAuth={goToAuth}
              setCardDetails={setCardDetails}
              otpIsRequired={otpIsRequired}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation() (Step3);
